import { Chip, styled } from '@mui/material';

export const GradientChip = styled(Chip)({
    background:
        'linear-gradient(90deg, #004899 0%, #004B9D 7.14%, #014EA1 14.29%, #0250A5 21.43%, #0253AA 28.57%, #0356AE 35.71%, #0459B2 42.86%, #045CB6 50%, #055FBA 57.14%, #0661BF 64.29%, #0764C3 71.43%, #0867C7 78.57%, #0A6ACB 85.71%, #0B6DD0 92.86%, #0C70D4 100%)',
    color: '#fff',
    borderRadius: '24px',
    height: '27px',
    '& .MuiChip-label': {
        fontSize: 11,
        fontWeight: 500,
        fontFamily: 'Inter',
    },
});
